<template>
    <page :busy="busy" :tabs="tabs">
        <router-view @busy="handleBusy"></router-view>
    </page>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Page from '../generic/page/page.vue';
    export default {
        components: {
            Page,
        },
        data() {
            return {
                busy: false,
            };
        },
        mounted() {
            if (this.$route.path === '/app/chat/settings/') {
                this.$router.push('/app/chat/settings/settings/');
            }
        },
        computed: {
            ...mapGetters('header', ['userSubscriberId', 'userPermissions']),
            tabs() {
                const tabs = [];
                tabs.push({
                    title: 'Settings',
                    route: '/app/chat/settings/settings/',
                    active: this.$route.path === `/app/chat/settings/settings/`,
                });
                if (this.userPermissions?.can_manage_inbox_permissions) {
                    tabs.push({
                        title: 'Permissions',
                        route: '/app/chat/settings/permissions/',
                        active: this.$route.path === `/app/chat/settings/permissions/`,
                    });
                }
                if (this.userPermissions?.can_manage_inbox_office_hours) {
                    tabs.push({
                        title: 'Office Hours',
                        route: '/app/chat/settings/office-hours/',
                        active: this.$route.path === `/app/chat/settings/office-hours/`,
                    });
                }
                return tabs;
            },
        },
        methods: {
            handleBusy(busy) {
                this.busy = busy;
            },
        },
    };
</script>

<style scoped lang="scss">
    @import '~bootstrap/scss/_functions.scss';
    @import '~bootstrap/scss/_variables.scss';
    @import '~bootstrap/scss/mixins/_breakpoints.scss';
    :deep(*) {
        font-family: 'Lato', sans-serif !important;
    }
</style>
